import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/media-validation/')({
  component: () => <Navigate to="/media-validation/litmus" />,
});
